import { render, staticRenderFns } from "./Stations.vue?vue&type=template&id=204dfb15&scoped=true&"
import script from "./Stations.vue?vue&type=script&lang=js&"
export * from "./Stations.vue?vue&type=script&lang=js&"
import style0 from "./Stations.vue?vue&type=style&index=0&id=204dfb15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204dfb15",
  null
  
)

export default component.exports